import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { useDispatch } from 'react-redux';
import { fetchData, removeData } from '../reduxactions/doctorapproveractions/DADoctorActions';
import useEffectOnce from '../hooks/useEffectOnce';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useNavigate } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';

export const DADoctors = () => {
    const uid = window.sessionStorage.getItem('uid');
    const usertype = window.sessionStorage.getItem('usertype');

    const [globalFilter, setGlobalFilter] = useState('');

    const data = useSelector((state: RootState) => state.dadoctor.get);

    const dispatch = useDispatch();




    //To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchData() as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffectOnce(() => {
        fetchDataAsync();
    }, [dispatch]);

    const cancelDelete = () => {
        setGroupConfirmation(false);
    };
    const navigate = useNavigate();
    const viewPage = (rowData: any) => {
        const url = `/viewdadoctorslists/${rowData.DoctorID}`;
        console.log('rowdata:', rowData.DoctorID)
        navigate(url);
    }
    const [groupConfirmation, setGroupConfirmation] = useState(false);

    const [group, setGroup] = useState({
        DoctorID: '',
    });

    const groupadmin = (rowData: any) => {

        setGroup({
            DoctorID: rowData.DoctorID,
        });
        setGroupConfirmation(true);
    };


    const Deletesss = async () => {
        const { DoctorID } = group;
        try {
            await dispatch(removeData(DoctorID) as any);
            // toast4.current.show({ severity: 'success', summary: 'successfully' ,life: 3000 });
            fetchDataAsync();
            setGroupConfirmation(false);
        } catch (error) {
            console.error('Error deleting data:', error);
        }
        fetchDataAsync();
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/doctors.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };

    return (
        <div className="main-content">
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="grid mb-2">
                            <div className="col-9">
                                <h2> Doctors List</h2>
                            </div>

                            <div className="col-3">
                                <a
                                    title="help"
                                    onClick={(e) => openWindow(e, IUrl)}
                                    style={{

                                        color: "blue",
                                        fontSize: 15, cursor: "pointer"
                                    }}
                                >Help for this Page &nbsp;
                                    <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card-header p-2"></div>
                            <div className="box box-primary">
                                <div className="card">
                                    <p className="m-0">
                                        <div>
                                            <div className="card flex flex-wrap justify-content">
                                                <span className="p-input-icon-left">
                                                    <i className="pi pi-search" />
                                                    <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                </span>
                                            </div>
                                            <div className="card">
                                                <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                    globalFilterFields={['FirstName', 'LastName', 'SpecilityName', 'Status']}>
                                                    <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                    <Column header="First Name" body={(rowData) => `${rowData.FirstName} `} />
                                                    <Column field="LastName" sortable header="LastName"></Column>
                                                    <Column field="SpecilityName" sortable header="Speciality"></Column>
                                                    <Column field="Status" sortable header="Status"></Column>
                                                    <Column header="Option" body={(rowData) => (
                                                        <div className="options-buttons">
                                                            <Button icon="pi pi-eye" rounded outlined tooltip="View" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={() => viewPage(rowData)} />

                                                            <Button icon="pi pi-trash" rounded outlined tooltip="Delete" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'red', width: '2rem', height: '2rem', marginLeft: '10px' }} onClick={() => groupadmin(rowData)} />
                                                        </div>
                                                    )}></Column>
                                                </DataTable>
                                            </div>
                                        </div>
                                    </p>




                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                < Dialog header="Confirm Delete" style={{ width: '30vw' }} visible={groupConfirmation} onHide={() => setGroupConfirmation(false)}>
                    <div>Are you really want to Remove...?</div>
                    <br></br>
                    <Button label="Delete" icon="pi pi-check" className='mr-3 p-button-raised' onClick={Deletesss} />
                    <Button label="Close" icon="pi pi-times" onClick={cancelDelete} className="mr-3 p-button-secondary" />
                </Dialog >
            </div >
        </div >
    )
}
